import React, { useState } from 'react';
import CompetitiveInfo from './competitive-info';
import MinusSVG from './icons/MinusSVG';
import PlusSVG from './icons/PlusSVG';
import Insights from './insights';
import ScriptTabContent from './script-tab-content';
import ShareFeedback from './share-feedback';

interface User {
	name: string;
	email: string;
}
interface ScriptTab {
	id: string;
	label: string;
	content: React.ReactNode;
}
interface ChatComponentProps {
	data: any;
	loggedInUserData?: User;
}

function classNames(...classes: string[]) {
	return classes.filter(Boolean).join(' ');
}

const AgentAssist: React.FC<ChatComponentProps> = ({ data, loggedInUserData }) => {
	const scriptTabs: ScriptTab[] = [
		{
			id: 'tab1',
			label: 'Assist',
			content: <ScriptTabContent data={data} />,
		},
		{ id: 'tab2', label: 'Transcript', content: <div>Coming Soon.....</div> },
		{
			id: 'tab3',
			label: 'Feedback',
			content: (
				<ShareFeedback
					loggedInUserData={loggedInUserData}
				/>
			),
		},
	];

	const [activeTab, setActiveTab] = useState(scriptTabs[0].id);

	const [scriptToggle, setScriptToggle] = useState(true);

	const scriptToggleHandle = () => {
		setScriptToggle(!scriptToggle);
	}

	const insightTabs = [
		{ id: 'insightstab', label: 'Insights', content: <Insights data={data} /> },
		{ id: 'compinfotab', label: 'Competitive Info', content: <CompetitiveInfo /> },
	];
	const [activeInsightTab, setActiveInsightTab] = useState(insightTabs[0].id);

	return (
		<>
			<div className="w-80">
				{/* Script Tabs */}
				<div className="p-4 pb-5 bg-[#97eeff] rounded-t-xl">
					<div className="rounded-lg bg-[#7edff2] flex justify-between items-start mb-4">
						{scriptTabs.map((tab) => (
							<button
								type="button"
								key={tab.id}
								className={classNames(
									activeTab === tab.id ? 'bg-[#1f1f1f] text-[#ffffff]' : 'bg-transparent text-[#1f1f1f]',
									'h-8 rounded-lg px-2 text-sm font-medium flex-1'
								)}
								onClick={() => setActiveTab(tab.id)}
							>
								{tab.label}
							</button>
						))}
					</div>

					<div className="accordion-header py-2 flex items-center justify-between cursor-pointer rounded-lg"
						onClick={scriptToggleHandle}>
						<h2 className="text-lg text-black font-semibold">Call flow script</h2>
						<div className="flex items-center justify-center w-5 h-5 bg-[#97EEFF] border border-gray-700 text-gray-700 rounded-full">
							{scriptToggle ? (
								<MinusSVG />
							) : (
								<PlusSVG />
							)}
						</div>
					</div>
					{
						scriptToggle && (
							<div>{
								scriptTabs.map((tab) => (
									<div key={tab.id} className={activeTab === tab.id ? '' : 'hidden'}>
										{tab.content}
									</div>
								))
							}
							</div>
						)
					}
				</div>

				{/* Insights */}
				<div className="p-4 pb-5 bg-[#7edff2] rounded-b-xl">
					<div className=" mb-3 w-56 h-8 text-sm">
						{insightTabs.map((tab) => (
							<button
								type="button"
								key={tab.id}
								className={classNames(
									activeInsightTab === tab.id ? 'border-b-4 border-slate-800 font-semibold text-[#000000]' : 'bg-transparent text-[#1f1f1f]',
									'h-8 rounded-m px-2 text-sm font-medium flex-1',
									'py-[6px]'
								)}
								onClick={() => setActiveInsightTab(tab.id)}
							>
								{tab.label}
							</button>
						))}
					</div>
					<div className="">
						{insightTabs.map((tab) => (
							<div key={tab.id} className={activeInsightTab === tab.id ? '' : 'hidden'}>
								{tab.content}
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
};

export default AgentAssist;